<template>
  <CContainer>
    <json-excel
      :fields="exportFields"
      :data="movementItems"
      name="MovimientoPedido.xls"
      worksheet="Movimientos"
      class="d-inline-block">
      <CButton 
        color="info" class="my-3">
        <CIcon name="cil-cloud-download" class="mr-2"></CIcon>
        <span>Excel</span>
      </CButton>
    </json-excel>

    <CDataTable
      hover
      striped
      responsive
      :pagination="true"
      :items-per-page="5"
      :fields="movementFields"
      :items="movementItems" >
      <template #producto="{item}">
        <td>
          <span>{{ item.Descripcion }}</span>
          <h5>{{ item.Codigo }}</h5>
        </td>
      </template>
      <template #detalles="{item}">
        <td>
          <div>
            {{ item.Referencia }}
          </div>
          <div>
            {{ item.Marca }}
          </div>
        </td>
      </template>
      <template #cantidad="{item}">
        <td>
          <div class="d-flex justify-content-end">
            {{ item.Cantidad }}
          </div>
        </td>
      </template>
      <template #valores="{item}">
        <td>
          <div class="d-flex justify-content-end">
            ${{ formatter.format(item.Valor_Producto, 0) }}
          </div>
          <div class="d-flex justify-content-end">
            ${{ formatter.format(item.Valor_Total, 0 )}}
          </div>
        </td>
      </template>
      <template #acciones="{item}">
        <td>
          <div class="d-flex justify-content-end">
            <a href="#" 
              class="mr-2"
              @click="(event) => setShowModalUpdate(event, item.Id_MovimientoPedido, item.Id_Producto, item.Cantidad, item.Valor_Producto)">
              <CIcon name="cil-pencil" size="lg" class="text-warning" />
            </a>
            <a href="#"
              class="mr-2"
              @click="event => tryDelete(event, item.Id_MovimientoPedido)">
              <CIcon name="cil-trash" class="text-danger" size="lg"/>
            </a>
          </div>
        </td>
      </template>
    </CDataTable>

    <CElementCover v-show="loading" />


    <CModal
      title="Actualizacion"
      color="info"
      :show.sync="activeUpdateModal"
      :centered="true"
      :closeOnBackdrop="false"
      :backdrop="true">
      <template v-slot:body-wrapper>
        <CContainer class="p-4">
          <CRow>
            <CCol col="12" sm="8">
              <CInput 
                label="Cantidad:" 
                :value.sync="productQuantity">
                <template #prepend-content>
                  <i class="bi bi-basket"></i>
                </template>
              </CInput>
            </CCol>
            <CCol>
              <CButton
                class="mt-4"
                color="success"
                @click="activeUpdateModal=false">
                <CIcon name="cil-x-circle" class="mr-2"/>
                Actualizar
              </CButton>
            </CCol>
          </CRow>
        </CContainer>
      </template>
      <template v-slot:footer>
        <CContainer class="d-flex justify-content-center">
          <CButton
            color="secondary"
            @click="activeUpdateModal=false">
            <CIcon name="cil-x-circle" class="mr-2"/>
            Cancelar
          </CButton>
        </CContainer>
      </template>
    </CModal>

  </CContainer>
</template>

<script>
  import JsonExcel from 'vue-json-excel'
  import { formatter } from '../../general'
  import CONSTANTS from "../../constants";
  import { dataGridMovimientosPedido } from '../../apiData'
  import { crudMovimientoPedidoCotizacion } from "../../apiCRUD"

  const movementFields = [
    { key: "producto", label: "Producto", _style: "text-align:center" },
    { key: "detalles", label: "", _style: 'text-align:center;' },
    { key: "cantidad", label: "Cantidad", _style: 'text-align:center;' },
    { key: "valores", label: "Valores", _style: 'text-align:center;' },
    { key: "acciones", label: "" }
  ]

  const exportFields = {
    'Código': 'Codigo',
    'Descripción': 'Descripcion',
    'Referencia': 'Referencia',
    'Cantidad': 'Cantidad',
    'Valor Producto': 'Valor_Producto',
    'Valor Total': 'Valor_Total'
  }

  export default {
    name: 'OrderQuoteDetail',
    data () {
      return {
        formatter,
        loading: false,
        movementItems: [],
        movementFields,
        exportFields,
        activeUpdateModal: false,
        selectedRecordId: "",
        productId: "",
        productQuantity: 0,
        productValue: 0
      }
    },
    components: {
      JsonExcel
    },
    props: {
      idOrderQuote: String
    },
    methods: {
      async getData() {
        if (this.idOrderQuote) {
          try {
            this.loading = true
            const { response } = await dataGridMovimientosPedido(this, this.idOrderQuote)
            this.movementItems = response
          } catch {
            this.$store.commit('setAlert', {
              color: "danger",
              message: 'Error al cargar datos',
              show: 5
            })
          } finally {
            this.loading = false
          }
        }
      },
      setShowModalUpdate(e, idMovimientoPedido, idProducto, cantidadProducto, valorProducto) {
        e.stopPropagation();

        this.selectedRecordId = idMovimientoPedido;
        this.productId = idProducto;
        this.productQuantity = cantidadProducto;
        this.productValue = valorProducto

        console.log(this.movementItems);
        

        this.activeUpdateModal = true;
      },
      tryDelete(e, idMovimientoPedido) {
        e.stopPropagation();

        this.selectedRecordId = idMovimientoPedido;
        CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar";
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "red";

        this.$confirm("¿Confirma que desea borrar este registro?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          this.deleteOrderMovement(idMovimientoPedido);
        }).catch(() => {
          this.$alert("Se cancelo la accion!", "", "warning" , CONSTANTS.configSimpleAlert)
        })
      },
      async deleteOrderMovement() {
        this.loading = true;

        try {
          await crudMovimientoPedidoCotizacion(this, "delete", this.selectedRecordId);

          this.getData();

          this.$store.commit("setAlert", {
            color: "success",
            message: CONSTANTS.messages.successfulAction,
            show: 5
          });
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: CONSTANTS.messages.notDoneDelete,
            show: 5
          });
        } finally {
          this.loading = false;
        }
      }
    }, 
    mounted() {
      this.getData()
    } 
  }
</script>